// Flag e config della modalità kiosk. Unica fonte di verità.
//
// Attivata a build-time da VUE_APP_KIOSK=true (vue-cli espone solo le variabili
// con prefisso VUE_APP_). Il build web normale NON ha il flag → nessuna delle
// funzionalità kiosk è visibile → il checkout online resta invariato.
//
// In modalità kiosk il checkout gira dentro il wrapper Electron che inietta
// `window.kioskPay` (vedi kiosk/electron/preload.js): il renderer non parla mai
// direttamente al Cashmatic né al backend, passa sempre da window.kioskPay.

export const IS_KIOSK = process.env.VUE_APP_KIOSK === 'true';

// Centro (sede) del totem, opzionale lato client: lato server il centerId
// autoritativo deriva comunque dal kiosk (config backend), questo è solo un hint.
export const KIOSK_CENTER_ID = process.env.VUE_APP_KIOSK_CENTER_ID || '';

// True se il ponte nativo è effettivamente presente (in dev browser non c'è).
export function hasKioskBridge() {
  return typeof window !== 'undefined' && !!window.kioskPay;
}

// Inattività nel checkout del totem: dopo KIOSK_IDLE_TIMEOUT_MS senza tocchi la
// sessione si annulla e si torna alla home. Il conto alla rovescia compare solo
// negli ultimi KIOSK_IDLE_WARNING_MS. Unico punto dove si cambiano le soglie.
export const KIOSK_IDLE_TIMEOUT_MS = 120000;
export const KIOSK_IDLE_WARNING_MS = 45000;
